import { render, staticRenderFns } from "./SelectedCarrier.vue?vue&type=template&id=702ca4cc&scoped=true&"
import script from "./SelectedCarrier.vue?vue&type=script&lang=js&"
export * from "./SelectedCarrier.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCarrier.vue?vue&type=style&index=0&id=702ca4cc&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ca4cc",
  null
  
)

export default component.exports